import { useCallback } from 'react';
import styled from 'styled-components';
import { OrgInfo, OrgLinkType } from '../../../../../../common/src/model.ts';
import { Panel, PanelContent, PanelTitle } from './shared.tsx';

export function ResourcesPanel({ orgInfo }: { orgInfo: OrgInfo | undefined }) {
  const { links } = orgInfo ?? {};
  return !links ? null : (
    <>
      <Panel>
        <PanelTitle>Invites</PanelTitle>
        <PanelContent>
          <Columns>
            <Column>
              {links?.[OrgLinkType.AdminInvite] && (
                <CopyInviteButton href={links[OrgLinkType.AdminInvite]}>Copy Admin Invite</CopyInviteButton>
              )}
              {links?.[OrgLinkType.StaffInvite] && (
                <CopyInviteButton href={links[OrgLinkType.StaffInvite]}>Copy Staff Invite</CopyInviteButton>
              )}
              {links?.[OrgLinkType.HouseholdInvite] && (
                <CopyInviteButton href={links[OrgLinkType.HouseholdInvite]}>Copy Household Invite</CopyInviteButton>
              )}
            </Column>
          </Columns>
        </PanelContent>
      </Panel>
      <Panel>
        <PanelTitle>Tutorials</PanelTitle>
        <PanelContent>
          <Columns>
            <Column>
              {links?.[OrgLinkType.CongregationTutorial] && (
                <ResourceLink href={links[OrgLinkType.CongregationTutorial]}>Congregation Tutorial</ResourceLink>
              )}
              {links?.[OrgLinkType.AdminTutorial] && (
                <ResourceLink href={links[OrgLinkType.AdminTutorial]}>Admin Tutorial</ResourceLink>
              )}
              {links?.[OrgLinkType.VideoMeeting] && (
                <ResourceLink href={links[OrgLinkType.VideoMeeting]}>Video Meeting</ResourceLink>
              )}
            </Column>
          </Columns>
        </PanelContent>
      </Panel>
    </>
  );
}

function CopyInviteButton({ href, children }: { href: string; children: React.ReactNode }) {
  const onClick = useCallback(() => {
    void navigator.clipboard.writeText(href);
  }, [href]);
  return <CopyInviteButtonWrapper onClick={onClick}>{children}</CopyInviteButtonWrapper>;
}

const Columns = styled.div`
  display: flex;
  gap: 5vw;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const buttonBorderThickness = '3px';
const buttonVerticalPadding = '2px';

const CopyInviteButtonWrapper = styled.button`
  color: var(--color-text);
  font-family: Jost-SemiBold, Arial, sans-serif;
  border: ${buttonBorderThickness} solid var(--color-text);
  border-radius: 30px;
  padding: ${buttonVerticalPadding} 8px;
  cursor: pointer;
  width: 20ch;
  &:active {
    color: var(--color-background);
    background-color: var(--color-text);
  }
`;

const ResourceLink = styled.a`
  font-family: Jost-SemiBold, Arial, sans-serif;
  color: var(--color-link);
  padding: calc(${buttonVerticalPadding} + ${buttonBorderThickness}) 0;
  text-align: left;
`;
